'use strict';

import {contractModel} from "../../models/contractmodel.js";
import {DSSectionCtrl} from "./dssectionctrl.js";

export class DSItemCtrl extends DSSectionCtrl
{
	
	postConstruct(){
		this.item = new contractModel(this.jsDataService.get('item', {}), this.$filter, this.jsDataService);
		
	}
	
	modelValue(name){
		if(typeof(this.item) !== 'undefined' && this.item instanceof contractModel){
			return this.item.getValue(name);
		}
		return '';
	}
	
	
}


